// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"647":"247c2043","985":"8f28d594"}[chunkId] + ".js";
};